import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

const ModalSubtitle = ({ id }) => {
  return (
    <div id={id} className="tl f5 c-on-base lh-copy mb6">
      <FormattedMessage id={id} />
    </div>
  )
}

ModalSubtitle.propTypes = {
  id: PropTypes.string.isRequired,
}

export default ModalSubtitle
